import { useContext } from 'react';

import { legacyGtmSupportProvider, GTMContext } from '../GTMContext';

export const useGTM = () => {
  const context = useContext(GTMContext);
  if (typeof window === 'undefined') {
    // Server-side: return no-op functions
    return legacyGtmSupportProvider;
  }
  if (!context) {
    throw new Error('useGTM must be used within a GTMProvider');
  }
  return context;
};
